<template>
  <container>
    <row class="mt-5 align-items-center justify-content-start">
      <h4 style="margin: 0" class="grey-text"><strong>Testimonials Sections</strong></h4>
      <a href="https://mdbootstrap.com/vue/sections/testimonials/#v-4" waves-fixed class="border grey-text px-2 border-light rounded ml-2" target="_blank"><fa icon="graduation-cap" class="mr-2"/>Docs</a>
    </row>
    <hr />
    <container>
      <section class="text-center my-5">
        <carousel :interval="8000" showControls showIndicators multi slide>
          <carousel-item>
            <row>
              <column md="4">
                <testimonial>
                  <avatar class="mx-auto">
                    <img src="https://mdbootstrap.com/img/Photos/Avatars/img%20(1).jpg" class="rounded-circle img-fluid"/>
                  </avatar>
                  <h4 class="font-weight-bold mt-4">Anna Deynah</h4>
                  <h6 class="blue-text font-weight-bold my-3">Web Designer</h6>
                  <p class="font-weight-normal"><fa icon="quote-left" class="pr-2"></fa>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod eos id officiis hic tenetur.</p>
                  <div class="grey-text">
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star-half-full"> </fa>
                  </div>
                </testimonial>
              </column>
              <column md="4" class="clearfix d-none d-md-block">
                <testimonial>
                  <avatar class="mx-auto">
                    <img src="https://mdbootstrap.com/img/Photos/Avatars/img%20(3).jpg" class="rounded-circle img-fluid"/>
                  </avatar>
                  <h4 class="font-weight-bold mt-4">John Doe</h4>
                  <h6 class="blue-text font-weight-bold my-3">Web Developer</h6>
                  <p class="font-weight-normal"><fa icon="quote-left" class="pr-2"></fa>Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis laboriosam.</p>
                  <div class="grey-text">
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                  </div>
                </testimonial>
              </column>
              <column md="4" class="clearfix d-none d-md-block">
                <testimonial>
                  <avatar class="mx-auto">
                    <img src="https://mdbootstrap.com/img/Photos/Avatars/img%20(31).jpg" class="rounded-circle img-fluid"/>
                  </avatar>
                  <h4 class="font-weight-bold mt-4">Abbey Clark</h4>
                  <h6 class="blue-text font-weight-bold my-3">Photographer</h6>
                  <p class="font-weight-normal"><fa icon="quote-left" class="pr-2"></fa>Quis autem vel eum iure reprehenderit qui in ea voluptate velit esse quam nihil molestiae.</p>
                  <div class="grey-text">
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star-o"> </fa>
                  </div>
                </testimonial>
              </column>
            </row>
          </carousel-item>
          <carousel-item>
            <row>
              <column md="4">
                <testimonial>
                  <avatar class="mx-auto">
                    <img src="https://mdbootstrap.com/img/Photos/Avatars/img%20(4).jpg" class="rounded-circle img-fluid"/>
                  </avatar>
                  <h4 class="font-weight-bold mt-4">Blake Dabney</h4>
                  <h6 class="blue-text font-weight-bold my-3">Web Designer</h6>
                  <p class="font-weight-normal"><fa icon="quote-left" class="pr-2"></fa>Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis laboriosam.</p>
                  <div class="grey-text">
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star-half-full"> </fa>
                  </div>
                </testimonial>
              </column>
              <column md="4" class="clearfix d-none d-md-block">
                <testimonial>
                  <avatar class="mx-auto">
                    <img src="https://mdbootstrap.com/img/Photos/Avatars/img%20(6).jpg" class="rounded-circle img-fluid"/>
                  </avatar>
                  <h4 class="font-weight-bold mt-4">Andrea Clay</h4>
                  <h6 class="blue-text font-weight-bold my-3">Front-end developer</h6>
                  <p class="font-weight-normal"><fa icon="quote-left" class="pr-2"></fa>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod eos id officiis hic tenetur quae.</p>
                  <div class="grey-text">
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                  </div>
                </testimonial>
              </column>
              <column md="4" class="clearfix d-none d-md-block">
                <testimonial>
                  <avatar class="mx-auto">
                    <img src="https://mdbootstrap.com/img/Photos/Avatars/img%20(7).jpg" class="rounded-circle img-fluid"/>
                  </avatar>
                  <h4 class="font-weight-bold mt-4">Cami Gosse</h4>
                  <h6 class="blue-text font-weight-bold my-3">Phtographer</h6>
                  <p class="font-weight-normal"><fa icon="quote-left" class="pr-2"></fa>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium.</p>
                  <div class="grey-text">
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star-o"> </fa>
                  </div>
                </testimonial>
              </column>
            </row>
          </carousel-item>
          <carousel-item>
            <row>
              <column md="4">
                <testimonial>
                  <avatar class="mx-auto">
                    <img src="https://mdbootstrap.com/img/Photos/Avatars/img%20(8).jpg" class="rounded-circle img-fluid"/>
                  </avatar>
                  <h4 class="font-weight-bold mt-4">Bobby Haley</h4>
                  <h6 class="blue-text font-weight-bold my-3">Web Developer</h6>
                  <p class="font-weight-normal"><fa icon="quote-left" class="pr-2"></fa>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod eos id officiis hic tenetur quae.</p>
                  <div class="grey-text">
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                  </div>
                </testimonial>
              </column>
              <column md="4" class="clearfix d-none d-md-block">
                <testimonial>
                  <avatar class="mx-auto">
                    <img src="https://mdbootstrap.com/img/Photos/Avatars/img%20(10).jpg" class="rounded-circle img-fluid"/>
                  </avatar>
                  <h4 class="font-weight-bold mt-4">Elisa Janson</h4>
                  <h6 class="blue-text font-weight-bold my-3">Marketer</h6>
                  <p class="font-weight-normal"><fa icon="quote-left" class="pr-2"></fa>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium.</p>
                  <div class="grey-text">
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star-half-full"> </fa>
                  </div>
                </testimonial>
              </column>
              <column md="4" class="clearfix d-none d-md-block">
                <testimonial>
                  <avatar class="mx-auto">
                    <img src="https://mdbootstrap.com/img/Photos/Avatars/img%20(9).jpg" class="rounded-circle img-fluid"/>
                  </avatar>
                  <h4 class="font-weight-bold mt-4">Rob Jacobs</h4>
                  <h6 class="blue-text font-weight-bold my-3">Front-end developer</h6>
                  <p class="font-weight-normal"><fa icon="quote-left" class="pr-2"></fa>Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis laboriosam.</p>
                  <div class="grey-text">
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star"> </fa>
                    <fa icon="star-o"> </fa>
                  </div>
                </testimonial>
              </column>
            </row>
          </carousel-item>
        </carousel>
      </section>
    </container>
  </container>
</template>

<script>
import { Carousel, CarouselItem, CarouselCaption, Container, Row, Column, Testimonial, Avatar, Fa } from 'mdbvue';

export default {
  name: 'CarouselPage',
  components: {
    Carousel,
    CarouselItem,
    CarouselCaption,
    Container,
    Row,
    Column,
    Testimonial,
    Avatar,
    Fa
  }
};
</script>

<style scoped>
</style>
